import { z } from "zod";

export const JobSchema = 
  z.object({
    id: z.string().uuid(),
    title: z.string(),
    description: z.string().nullable(),
    comercialName: z.string(),
    pictureCompany: z.string().nullable(),
    workMode: z.string().nullable(),
    experienceLevel: z.string().nullable(),
    jobLocation: z.string().nullable(),
    minMonthlyBudget: z.number(),
    maxMonthlyBudget: z.number(),
    createdAt: z.string().transform((dateStr) => new Date(dateStr)),
  });

export const JobsSchema = z.array(JobSchema);

export type Job = z.infer<typeof JobSchema>;
